module.exports = __webpack_public_path__ + "img/wenhao.1b36796b.svg";